module.exports = __webpack_public_path__ + "img/2017h5.92152eb0.jpg";